const apiConfig = {
    baseUrl: 'https://api.themoviedb.org/3/',
    apiKey: '30c2a2ee96236d9e41290809a7bb2111',
    /*apiKey: '4231f7ce767c9824854758b3fb4de2',*/
    originalImage: (imgPath) => `https://image.tmdb.org/t/p/original/${imgPath}`,
    w500Image: (imgPath) => `https://image.tmdb.org/t/p/w500/${imgPath}`
}

export default apiConfig;
